import api from './api'
import { ENDPOINTS } from './constants'
import {
  CampaignCostEstimate,
  CampaignCostInput,
  CostVolumes,
  MonthlyCostEstimate,
} from '@/models/whatsappCosts'

export const COST_CATEGORY_LABELS = {
  MARKETING: 'Marketing',
  UTILITY: 'Utilidade',
  AUTHENTICATION: 'Autenticação',
  SERVICE: 'Serviço',
}
export const emptyCostVolumes = (): CostVolumes => ({
  marketing: 0,
  utility: 0,
  authentication: 0,
  service: 0,
  utilityInWindow: 0,
  unknown: 0,
})
export const currentCostMonth = () =>
  [
    '2026-10',
    new Intl.DateTimeFormat('sv-SE', {
      timeZone: 'America/Recife',
      year: 'numeric',
      month: '2-digit',
    }).format(new Date()),
  ]
    .sort()
    .at(-1)!
export const formatCost = (value: string | null, currency: string) =>
  value === null
    ? 'Indisponível'
    : `${currency} ${new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value))}`
export const formatUnitCost = (value: string | null, currency: string) =>
  value === null
    ? 'Não cadastrada'
    : `${currency} ${new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 6 }).format(Number(value))}`
export const previewCampaignCost = async (
  input: CampaignCostInput,
  signal?: AbortSignal,
) =>
  (
    await api.post<CampaignCostEstimate>(
      ENDPOINTS.WHATSAPP_COSTS.CAMPAIGN_PREVIEW,
      input,
      { signal },
    )
  ).data
export const simulateMonthlyCost = async (
  month: string,
  direct: CostVolumes,
  broadcast: CostVolumes,
  costCurrency: 'USD' | 'BRL',
  signal?: AbortSignal,
) =>
  (
    await api.post<MonthlyCostEstimate>(
      ENDPOINTS.WHATSAPP_COSTS.SIMULATE,
      { month, direct, broadcast, costCurrency },
      { signal },
    )
  ).data
export function costError(error: unknown): string {
  const value = error as { response?: { data?: { message?: unknown } } }
  const message = value.response?.data?.message
  return typeof message === 'string'
    ? message
    : 'Não foi possível calcular. Tente novamente.'
}

// Same date construction used by the existing scheduled-message form serializer.
export function scheduledCostInput(
  data: import('@/models/scheduledMessage').ScheduledMessageFormData,
): CampaignCostInput | null {
  if (
    !data.transmissionListId ||
    !data.whatsappTemplateConfig ||
    data.type !== 'Template WhatsApp'
  )
    return null
  let date = data.date
  const now = new Date()
  const display = (value: Date) =>
    `${String(value.getDate()).padStart(2, '0')}/${String(value.getMonth() + 1).padStart(2, '0')}/${value.getFullYear()}`
  if (['Diária', 'Semanal'].includes(data.recurrence)) date = display(now)
  else if (['Mensal', 'Trimestral'].includes(data.recurrence)) {
    now.setDate(Number(data.day))
    date = display(now)
  }
  if (!/^\d{2}\/\d{2}\/\d{4}$/.test(date) || !/^\d{2}:\d{2}$/.test(data.time))
    return null
  const timestamp = (value: string, time: string) =>
    `${value.split('/').reverse().join('-')} ${time}`
  return {
    transmissionListId: Number(data.transmissionListId),
    templateId: Number(data.whatsappTemplateConfig.templateId),
    scheduledAt: timestamp(date, data.time),
    endAt:
      data.recurrence && data.endAt
        ? timestamp(data.endAt, '23:59')
        : undefined,
    recurrence: data.recurrence || undefined,
    businessDayStrategy: data.businessDayStrategy || undefined,
    dayOfWeek: data.dayOfWeek ? Number(data.dayOfWeek) : undefined,
    onlyBusinessDays: data.onlyBusinessDays,
  }
}
